document.addEventListener('trix-before-initialize', () => {
  for (let i = 2; i <= 6; i++) {
    Trix.config.blockAttributes['heading' + i] = {
      tagName: 'h' + i,
      terminal: true,
      breakOnReturn: true,
    }
  }
})

document.addEventListener('trix-initialize', (event) => {
  const toolbar = event.target.toolbarElement

  if (toolbar.dataset.customized) return
  toolbar.dataset.customized = true

  const h1Button = toolbar.querySelector('.trix-button--icon-heading-1')

  for (let i = 6; i >= 1; i--) {
    h1Button.insertAdjacentHTML(
      'afterend',
      `<button type="button" class="trix-button" data-trix-attribute="heading${i}">H${i}</button>`,
    )
  }

  h1Button.remove()

  if (location.pathname.includes('documents')) {
    toolbar
      .querySelector('.trix-button-group--block-tools')
      .insertAdjacentHTML(
        'beforeend',
        `<button type="button" class="trix-button" data-trix-action="x-school-name">School Name</button>`,
      )

    toolbar
      .querySelector('.trix-button-group--block-tools')
      .insertAdjacentHTML(
        'beforeend',
        `<button type="button" class="trix-button" data-trix-action="x-school-business-id">School Business ID</button>`,
      )

    toolbar
      .querySelector('.trix-button-group--block-tools')
      .insertAdjacentHTML(
        'beforeend',
        `<button type="button" class="trix-button" data-trix-action="x-school-address">School Address</button>`,
      )

    toolbar
      .querySelector('.trix-button-group--block-tools')
      .insertAdjacentHTML(
        'beforeend',
        `<button type="button" class="trix-button" data-trix-action="x-school-phone-number">School Phone</button>`,
      )

    toolbar
      .querySelector('.trix-button-group--block-tools')
      .insertAdjacentHTML(
        'beforeend',
        `<button type="button" class="trix-button" data-trix-action="x-school-email">School Email</button>`,
      )
  }
})

document.addEventListener('trix-action-invoke', (event) => {
  const { editor } = event.target

  switch (event.actionName) {
    case 'x-school-address':
      editor.insertString('{{school_address}}')
      break
    case 'x-school-business-id':
      editor.insertString('{{school_business_id}}')
      break
    case 'x-school-email':
      editor.insertString('{{school_email}}')
      break
    case 'x-school-name':
      editor.insertString('{{school_name}}')
      break
    case 'x-school-phone-number':
      editor.insertString('{{school_phone_number}}')
      break
    default:
      break
  }
})
